import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { IAnnouncement } from "../../models/announcement.model";
import { environment } from "src/environments/environment";
import { AnnouncementService } from "../../services/announcement.service";
import { MatCardModule } from "@angular/material/card";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { SanitizeHtmlPipeModule } from "../../../shared/pipes/sanitize-html-pipe.module";
import { MatButtonModule } from "@angular/material/button";
import { ApplicationsComponent } from "../applications/applications.component";
import { NavigationEnd, Router } from "@angular/router";
import { GoogleTagManagerService } from "angular-google-tag-manager";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    imports: [
        CommonModule,
        MatCardModule,
        MatAccordion,
        MatExpansionModule,
        SanitizeHtmlPipeModule,
        ApplicationsComponent,
        MatButtonModule,
    ]
})
export class HomeComponent implements OnInit {
  name!: string | null;
  hideApplicationButton: boolean = false;
  userIsAdmin: boolean = false;
  iwaAppUrl!: string;

  ELEMENT_DATA: IAnnouncement[] = [];
  editorReadSantStyle = {
    height: "100px",
    alignment: "MJ Selected-Quill",
  };
  constructor(
    private service: AnnouncementService,
    private authService: AuthenticationService,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    // Since home is landing page we implement gtm so it will add every page that the user will click from now on
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        console.log(item);
        const gtmTag = {
          event: "page",
          pageName: item.url,
        };

        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  ngOnInit() {
    this.getData();
    var userInfo = this.authService.getUserInfo();
    this.name = userInfo?.name || "";
    this.iwaAppUrl = environment.iwaAppUrl;

    this.hideApplicationButton = !(
      this.authService.isAgent() || this.authService.isAgencyAdmin()
    );
    this.userIsAdmin = this.authService.hasRole("Admin");
    console.log("userIsAdmin value is: " + this.userIsAdmin);
  }

  getData() {
    this.service
      .getAll("/announcements/")
      .subscribe((announcement: IAnnouncement[]) => {
        // console.log(announcement);
        this.ELEMENT_DATA = announcement;
      });
  }

  goToIwaApp() {
    window.open(this.iwaAppUrl);
  }
}
